import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import CodeIcon from '@mui/icons-material/Code';
import DescriptionIcon from '@mui/icons-material/Description';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Colors } from '../../../landingPage/style/theme';
import SecondaryButton from '../../../landingPage/Assets/SecondaryButton';

const apiData = [
  {
    name: 'IP Quality Check and Location Data API ',
    description: 'IP Quality Check and Location Data API  identifies IP reputation, detects fraud, and provides precise geographic location insights.',
    link: '/dashboard/IpQualityCheck',
    isLive: true,
  },
  {
    name: 'IP to Currency and Location Data API',
    description: 'API to find currency through ip address.',
    link: '/dashboard/IpToCurrencyCheck',
    isLive: true,
  },
  {
    name: 'IP to Time-Zone and Location Data API',
    description: 'API to find time-zone and language through ip address.',
    link: '/dashboard/IpToTimeAndLanguageCheck',
    isLive: true,
  },
  {
    name: 'Mobile Number Verification API',
    description: 'Verify phone numbers in real time to enhance security, reduce fake sign-ups, and improve user authentication.',
    link: '/dashboard/MobileNumberVerificationCheck',
    isLive: false,
  },
  {
    name: 'Geocoding & Reverse Geocoding',
    description: 'Convert addresses into geographic coordinates and vice versa for accurate location mapping and enhanced user experiences.',
    link: '/dashboard/GeocodingAndReverseGeocoding',
    isLive: false,
  },
  {
    name: 'Name Matching',
    description: 'Ensure accurate identity verification with intelligent name-matching algorithms, reducing errors in customer records and fraud detection.',
    link: '/dashboard/NameMatching',
    isLive: false,
  }
];

export default function DashboardView() {
  const [searchTerm, setSearchTerm] = useState('');
  // const [copySuccess, setCopySuccess] = useState(false);
  // const token = localStorage.getItem('token');
  // const userAPIToken = localStorage.getItem('apikey');




  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  // Copy token to clipboard
  // const handleCopyToken = () => {
  //   navigator.clipboard.writeText(userAPIToken);
  //   setCopySuccess(true);
  //   setTimeout(() => setCopySuccess(false), 2000); // Reset success message after 2 seconds
  // };

  const filteredAPIs = apiData.filter((api) =>
    api.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <Grid container spacing={2} alignItems="center">
        {/* Display User Token */}
        {/* <Grid item xs={12} container justifyContent="space-between" alignItems="center"> */}
        {/* <Grid item xs={8}>
            <Typography
              variant="body1"
              sx={{ fontWeight: 'bold', color: Colors.primary }}
            >
              Your API Key:
            </Typography>
            <Box
              sx={{
                background: '#eaeaea',
                padding: '6px',
                borderRadius: '4px',
                overflowX: 'auto',
                fontFamily: 'monospace',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Typography
                variant="body2"
                pl={1}
                sx={{
                  fontFamily: 'monospace',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  flexGrow: 1,
                }}
              >
                {userAPIToken}
              </Typography>
              <Tooltip title={copySuccess ? 'Copied!' : 'Copy'}>
                <IconButton onClick={handleCopyToken}>
                  <ContentCopyIcon sx={{ fontSize: 20, color: Colors.primary }} />
                </IconButton>
              </Tooltip>
            </Box>
          </Grid> */}

        {/* </Grid> */}

        {/* Search and Show All APIs Button */}
        <Grid item xs={12} container justifyContent="space-between" alignItems="center" sx={{ mt: 2 }}>
          <Grid item xs={6} sm={6} md={4}>
            <TextField
              fullWidth
              size="small"
              placeholder="Search for API name"
              value={searchTerm}
              onChange={handleSearchChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              variant="outlined"
            />
          </Grid>

          <Grid item xs="auto">
            {/* <Button
              variant="contained"
              component={Link}
              to="/dashboard/documentation"
              sx={{
                backgroundColor: Colors.primary,
                color: '#fff',
                '&:hover': {
                  backgroundColor: Colors.secondary,
                },
              }}
            >
              Show all APIs
            </Button> */}
            <SecondaryButton size='normal' text="Show all API's" to="/dashboard/documentation" />
          </Grid>
        </Grid>
      </Grid>

      {/* API List */}
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {filteredAPIs.length > 0 ? (
          filteredAPIs.map((api, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                variant="outlined"
                component={api.isLive ? Link : 'div'} // Keep interactivity only if isLive is true
                to={api.isLive ? api.link : undefined}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: 2,
                  height: 150,
                  textDecoration: 'none',
                  color: 'inherit',
                  transition: '0.3s',
                  borderColor: 'transparent',
                  borderRadius: '8px',
                  position: 'relative',
                  filter: api.isLive ? 'none' : 'blur(1px) brightness(0.7)', // Blur effect for disabled APIs
                  pointerEvents: api.isLive ? 'auto' : 'none', // Disable interactions if not live
                  '&:hover': {
                    borderColor: api.isLive ? Colors.primary : 'transparent',
                    boxShadow: api.isLive ? 3 : 'none',
                    cursor: api.isLive ? 'pointer' : 'default',
                  },
                }}
              >
                {!api.isLive && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      backgroundColor: 'rgba(0, 0, 0, 0.6)', // Dark overlay
                      color: 'white',
                      padding: '8px 16px',
                      borderRadius: '4px',
                      fontWeight: 'bold',
                      zIndex: 1, // Ensure text appears above blurred content
                    }}
                  >
                    Coming Soon
                  </Box>
                )}
                <Box sx={{ flexShrink: 0, mr: 2 }}>
                  <IntegrationInstructionsIcon style={{ fontSize: 40, color: Colors.primary }} />
                </Box>
                <CardContent sx={{ flexGrow: 1, overflow: 'hidden' }}>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                  >
                    {api.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'text.secondary',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                    }}
                  >
                    {api.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))
        ) : (
          <Grid item xs={12}>
            <Typography variant="body1">No APIs found matching your search.</Typography>
          </Grid>
        )}
      </Grid>


      <Grid item xs={12} sx={{ mt: 10 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Card variant="outlined" sx={{ padding: 2, borderRadius: '8px' }}>
              <Typography variant="h6">Get Integrated Quick</Typography>
              <Box display="flex" alignItems="center" mt={1}>
                <DescriptionIcon sx={{ fontSize: { xs: 40, sm: 50 }, color: Colors.primary }} />
                <Box ml={2}>
                  <Typography variant="body1">View our API Documentation</Typography>
                  <Button
                    variant="text"
                    component={Link}
                    to="/dashboard/documentation"
                    endIcon={<ArrowForwardIcon />}
                    style={{ color: Colors.primary }}
                    color='primary'
                  >
                    Go to Integration Docs
                  </Button>
                </Box>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Card variant="outlined" sx={{ padding: 2, borderRadius: '8px' }}>
              <Typography variant="h6">Add Credits</Typography>
              <Box display="flex" alignItems="center" mt={1}>
                <CodeIcon sx={{ fontSize: { xs: 40, sm: 50 }, color: Colors.primary }} />
                <Box ml={2}>
                  <Typography variant="body1">Generate API credentials</Typography>
                  <Button
                    variant="text"
                    component={Link}
                    to="/dashboard/wallet"
                    endIcon={<ArrowForwardIcon />}
                    style={{ color: Colors.primary }}
                  >
                    Go to Credits
                  </Button>
                </Box>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
